import { Box, Button, Stack, Typography } from '@mui/material';
import theme from '../../theme';
import { useState } from 'react';
import CreateOrganisationModal from '../modals/CreateOrganisationModal';
import JoinOrganisationModal from '../modals/JoinOrganisationModal';

const styles = {
  pageContainer: {
    display: 'flex',
    height: '100vh',
    justifyContent: 'center',
    alignItems: 'center',
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '8px',
    backgroundColor: '#FFFFFF',
    padding: '24px',
    border: `1px solid ${theme.palette.lightGray.main}`,
    gap: '16px',
  },
  header: {
    gap: 0.5,
  },
  title: {
    fontSize: '20px',
    fontWeight: 500,
  },
  subtitle: {
    fontSize: '14px',
    fontWeight: 400,
    color: 'text.secondary',
    textAlign: 'center',
  },
  buttonContainer: {
    gap: 2,
  },
  button: {
    boxShadow: 'none',
    textTransform: 'none',
  },
};

const CreateOrJoinOrg = () => {
  const [isCreateModalOpen, setIsCreateModalOpen] = useState<boolean>(false);
  const [isJoinModalOpen, setIsJoinModalOpen] = useState<boolean>(false);

  const handleCloseCreateModal = () => {
    setIsCreateModalOpen(false);
  };
  const handleCloseJoinModal = () => {
    setIsJoinModalOpen(false);
  };

  return (
    <Box sx={styles.pageContainer}>
      <Box sx={styles.root}>
        <Stack sx={styles.header} direction="row">
          <Typography
            sx={{ ...styles.title, color: theme.palette.custom.textBlue }}
          >
            Create
          </Typography>
          <Typography
            sx={{ ...styles.title, color: theme.palette.text.secondary }}
          >
            or
          </Typography>
          <Typography
            sx={{ ...styles.title, color: theme.palette.custom.textBlue }}
          >
            Join
          </Typography>
          <Typography
            sx={{ ...styles.title, color: theme.palette.text.secondary }}
          >
            Organization
          </Typography>
        </Stack>
        <Typography sx={styles.subtitle}>
          Create a new organization or join an existing one to collaborate
          seamlessly
        </Typography>
        <Stack direction="row" sx={styles.buttonContainer}>
          <Button
            variant="contained"
            sx={styles.button}
            onClick={() => setIsCreateModalOpen(true)}
          >
            Create Organization
          </Button>
          <Button
            variant="outlined"
            sx={styles.button}
            onClick={() => setIsJoinModalOpen(true)}
          >
            Join Organization
          </Button>
        </Stack>
      </Box>

      <CreateOrganisationModal
        open={isCreateModalOpen}
        onClose={handleCloseCreateModal}
      />
      <JoinOrganisationModal
        open={isJoinModalOpen}
        onClose={handleCloseJoinModal}
      />
    </Box>
  );
};

export default CreateOrJoinOrg;
